<template>
  <div class="main-wrapper management">
    <div class="main-header management">
      <Header />
    </div>
    <div class="main-content management">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from "@/components/sideComponents/Header";
import { useCookie } from "vue-cookie-next";
import { onMounted } from "@vue/runtime-core";

export default {
  name: "App",
  components: {
    Header,
  },
  setup() {
    onMounted(() => {
      const cookie = useCookie();
      cookie.setCookie("lang", localStorage.getItem("language"));
    });
  },
};
</script>
<style lang="scss">
@import "@/styles/app.scss";
@import "@/styles/table.scss";
@import "@/styles/header.scss";
@import "@/styles/licenseModal.scss";
@import "@/styles/login.scss";
@import "@/styles/templateModal.scss";
@import "@/styles/userModal.scss";
@import "@/styles/attach.scss";
</style>
